{
  "fr": {
    "languages": {
      "ar": "Arabe",
      "cs": "Tchèque",
      "da": "Danois",
      "de": "Allemand",
      "el": "Grec",
      "en": "Anglais",
      "es": "Espagnol",
      "fi": "Finnois",
      "fr": "Français",
      "he": "Hébreu",
      "hu": "Hongrois",
      "it": "Italien",
      "ja": "Japonais",
      "ko": "Coréen",
      "nl": "Néerlandais",
      "no": "Norvégien",
      "pl": "Polonais",
      "pt": "Portugais",
      "ro": "Roumain",
      "ru": "Russe",
      "sk": "Slovaque",
      "sv": "Suédois",
      "th": "Thaï",
      "uk": "Ukrainien",
      "vi": "Vietnamien",
      "zh": "Chinois"
    }
  }
}
